module.exports = __webpack_public_path__ + "img/minimize.582f52d0.svg";